/**
 * @name useClickOutside
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Hook para detectar cliques fora do menu e fechá-lo.
 * @package src/components/layouts/UserLayout/components/UserSideBar/hooks/useClickOutside.ts
 **/

import { useEffect } from 'react';

export const useClickOutside = (isOpen: boolean, onClose: () => void) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const drawer = document.querySelector('.MuiDrawer-paper');
      if (drawer && !drawer.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen, onClose]);
};
